export default __webpack_public_path__ + "static/media/ca-logo-reverse-stroke.b7fabfe2.svg";